// extracted by mini-css-extract-plugin
export default {"wrapper":"Io","form":"Jo","required":"Ko","label":"Lo","small":"Mo","noMargin":"No","success":"Oo","circle":"Po","successText":"Qo","appointment":"Ro"};